import { useEffect } from 'react';
import { PlayCircleOutlined } from '@ant-design/icons';
import { useAuth } from '@frontegg/react';
import { analytics, logger } from 'src/services';

export const SupaDemo = ({ className, isMobileView, children }) => {
  const { user } = useAuth();

  useEffect(() => {
    if (window.Supademo) {
      window.Supademo(import.meta.env.VITE_SUPADEMO_PROJECT_ID, {
        variables: {
          email: user.email ?? '',
          name: user?.name ?? '', // optional user name
        },
      });
    } else {
      logger.warn("Supademo script couldn't initialize on time");
    }
  }, [user.email, user?.name]);

  if (children) {
    return <>{children}</>;
  }

  const mobileViewActive = isMobileView || window.innerWidth < 1260;

  return (
    <>
      <button
        className={className}
        type="button"
        data-supademo-showcase={import.meta.env.VITE_SUPADEMO_SHOWCASE_ID}
        onClick={() => {
          // eslint-disable-next-line no-undef
          analytics.track('Clicked View Demo From Top Menu', {
            email: user?.email,
          });
        }}
      >
        <PlayCircleOutlined />
        {mobileViewActive ? null : 'View Demo'}
      </button>
    </>
  );
};
